import React from 'react';
//importar browserroute para usar route
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import PrincipalPage from '../pages/PrincipalPage';
import Contact from '../pages/Contact';
import Proyects from '../pages/Proyects'

import Layout from './Layout';
import NotFound from '../pages/NotFound';


import Web from '../proyectpages/Web';
import Game from '../proyectpages/Game';
import BI from '../proyectpages/BI';
import AppD from '../proyectpages/AppD';



//proyects
//apps
import Cinegon from '../proyectpages/listApp/Cinegon';
import Kanjaban from '../proyectpages/listApp/Kanjaban';

//web
import Gameover from '../proyectpages/listWeb/Gameover';
import Pizza from '../proyectpages/listWeb/Pizza';
import Oldporfolio from '../proyectpages/listWeb/Oldporfolio';
//bi
import kanjabanbi from '../proyectpages/listBI/Kanjabanbi';
import Cinegonbi from '../proyectpages/listBI/Cinegonbi';
import Biapp from '../proyectpages/listBI/Biapp';
import Gameoverbi from '../proyectpages/listBI/Gameoverbi';

//game
import Runordie from '../proyectpages/listGame/Runordie';

function App(){
   return(
      <React.Fragment>
      
      <BrowserRouter>
       
      <Layout>
        <Switch>
         <Route exact path="/porfolio-v2.0" component={PrincipalPage}/>
         <Route exact path="/Proyects" component={Proyects}/>
         <Route exact path="/Contact" component={Contact}/>
         <Route exact path="/webdevelopment" component={Web}/>
         <Route exact path="/desktopapp" component={AppD}/>
         <Route exact path="/bi" component={BI}/>
         <Route exact path="/games" component={Game}/>




         <Route exact path="/gameoverweb" component={Gameover}/>
         <Route exact path="/pizzahot" component={Pizza}/>
         <Route exact path="/oldporfolio" component={Oldporfolio}/>
         


         <Route exact path="/kanjaban" component={Kanjaban}/>
         <Route exact path="/cinegon" component={Cinegon}/>


         <Route exact path="/kanjabandb" component={kanjabanbi}/>
         <Route exact path="/cinegondb" component={Cinegonbi}/>
         <Route exact path="/bidb" component={Biapp}/>
         <Route exact path="/gameoverwebdb" component={Gameoverbi}/>

         <Route exact path="/runordie" component={Runordie}/>


         <Route component={NotFound}/>
        </Switch>
        
      </Layout>
     
      
      </BrowserRouter>
      
      </React.Fragment>

   );
}



export default App;